import axios from 'axios'
// import EventHub from '@/eventHub'

// Création d'une instance Axios
const instance = axios.create({
    baseURL: 'https://hister-api.va-net.fr/api/',
    timeout: 20000,
    headers: {
        'Accept': 'application/json, text/plain, */*'
    },
    transformResponse: [function (data) {
        // 🔒 Sécurise le parsing même si la réponse n'est pas en JSON
        if (!data) return null
        try {
            return JSON.parse(data)
        } catch (e) {
            // Si ce n’est pas du JSON, on renvoie brut
            return data
        }
    }]
})

// ✅ Intercepteur pour les réponses
instance.interceptors.response.use(
    response => {
        const data = response.data

        // Si le backend renvoie une structure spécifique
        if (data?.error && data.display_error == 1) {
            // EventHub.$emit('error-toast', data.error)
            // return Promise.reject(data.error)
        }

        // Si le backend enveloppe les données dans `api`
        if (data?.api) {
            return data.api
        }

        // Cas normal : renvoie le contenu brut
        return data
    },
    error => {
        // ⚠️ Gestion des erreurs réseau et HTTP
        let message = 'Erreur inconnue'

        if (error.response) {
            const status = error.response.status
            const data = error.response.data

            if (status === 404) message = 'Ressource introuvable'
            else if (status === 500) message = 'Erreur serveur'
            else if (status === 401) message = 'Non autorisé'
            else if (typeof data === 'string') message = data
            else if (data?.message) message = data.message
        } else if (error.request) {
            message = 'Le serveur ne répond pas'
        } else if (error.message) {
            message = error.message
        }

        console.error('❌ API Error:', message)
        // EventHub.$emit('error-toast', message)

        return Promise.reject(error)
    }
)

export default instance
